import { connection, API_BASE_URL } from './index';

const getLeaderboardRanking = async noAuth => {
  return await connection.get(API_BASE_URL + 'users/leaderboard');
};

export default { getLeaderboardRanking };
